import classNames from 'classnames';

interface Props {
  timeLeft: number;
}

const TimerBadge = ({ timeLeft }: Props) => {
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  const isExpired = timeLeft <= 0;

  const timerClasses = classNames(
    'md:rounded-2xl rounded-xl border-2 py-1 md:px-4 px-2 flex items-center justify-center',
    {
      'border-gray-300 bg-gray-100 text-neutral-600': !isExpired,
      'border-red-500 bg-red-50 text-neutral-900 shadow-[0_0_15px_rgba(239,68,68,0.3)]':
        isExpired
    }
  );

  return (
    <div className={timerClasses} role="timer" aria-live="polite">
      <span className="md:text-2xl text-base font-black">{formattedTime}</span>
    </div>
  );
};

export default TimerBadge;
